import { Channel } from 'packages/lane-shared/types/ChannelType';
import { createContext } from 'react';

export type ChannelAdminContextType = {
  loading: boolean;
  timeZone: string;
  specialPermissions: string[];
  channel: Channel | undefined;
  error: Error | null;
  called: boolean;
  refetchChannel: () => void;
};

const ChannelAdminContext = createContext({
  loading: false,
  timeZone: '',
  specialPermissions: [],
  channel: undefined,
  error: null,
  called: false,
  refetchChannel: () => null,
} as ChannelAdminContextType);

export default ChannelAdminContext;
